import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import Carousel from './Carousel'
import Icon from './Icon'
import Button from './Button'

const VerticalSliderItem = ({ icon, title, content }) => {
  return (
    <div className='verticals-carousel-item bg-white mx1 px2 center flex flex-column justify-center'>
      <div className='verticals-carousel-item__body'>
        {icon && (
          <Icon
            className='verticals-carousel-item__icon icon mb3'
            icon={icon}
          />
        )}
        <div className='verticals-carousel-item__title h3 mb1'>{title}</div>
        {content && (
          <div className='mb2' dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    </div>
  )
}

class VerticalsCarousel extends Component {
  constructor () {
    super()
    this.state = { hasMounted: false }
  }
  componentDidMount () {
    // NOTE: normally a bad idea to setState in componentDidMount,
    // as it causes extra render - but that is _exactly_ what we need here.
    // We have to force this re-render here client side _after_ the initial
    // reactDOM.hydrate, because this method does not make up for differences between
    // what we return on the server and what we need on the client
    // (which is viewport size dependant)
    this.setState({ hasMounted: true })
  }
  render () {
    const {
      slides,
      extraClass,
      greaterThanSm,
      greaterThanMd,
      greaterThanLg,
      greaterThanXl,
      greaterThanXxl
    } = this.props
    const { hasMounted } = this.state
    if (!hasMounted) {
      // we don’t know how many items we can show on the server..
      return (
        <div className={extraClass}>
          {slides && <VerticalSliderItem {...slides[0]} />}
        </div>
      )
    }
    const slidesToShow = greaterThanMd ? 3 : 1
    const slidesInViewport = slidesToShow > 1 ? slidesToShow + 2 : slidesToShow
    let centerPadding = '40px'
    if (greaterThanMd) {
      // availableWidth is just an approximation
      // We want to keep the slider items roughly the same fixed width, but that's
      // not easy to do with slider library, so we somewhat fake this effect via
      // modifying the center padding (how much of the extra items on the sides to show).
      let availableWidth = 850
      if (greaterThanLg) {
        availableWidth = 1000
      }
      if (greaterThanXl) {
        availableWidth = 1300
      }
      if (greaterThanXxl) {
        availableWidth = 1500
      }
      const itemWidth = availableWidth / slidesInViewport
      const ratioOfSideItemsShowing = availableWidth > 850 ? 0.85 : 0.5
      centerPadding = `${ratioOfSideItemsShowing * itemWidth}px`
    } else if (greaterThanSm) {
      centerPadding = '120px'
    }

    return (
      <Carousel
        extraClass={classnames('verticals-carousel', extraClass)}
        sliderOptions={{
          slidesToShow,
          centerPadding,
          centerMode: true,
          dots: false,
          arrows: true,
          autoplay: false,
          // doesn’t make sense with centerMode
          // infinite: false,
          // need extra divs because react-slick overrides the classname on the element passed in
          prevArrow: (
            <div>
              <Button className='button button--secondary'>
                <Icon icon='carousel-arrow-left' />
              </Button>
            </div>
          ),
          nextArrow: (
            <div>
              <Button className='button button--secondary'>
                <Icon icon='carousel-arrow-right' />
              </Button>
            </div>
          )
        }}
        slides={slides}
        slideRenderFn={VerticalSliderItem}
      />
    )
  }
}

VerticalsCarousel.propTypes = {
  extraClass: PropTypes.string,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      content: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
    }).isRequired
  ).isRequired,
  greaterThanSm: PropTypes.bool.isRequired,
  greaterThanMd: PropTypes.bool.isRequired,
  greaterThanLg: PropTypes.bool.isRequired,
  greaterThanXl: PropTypes.bool.isRequired,
  greaterThanXxl: PropTypes.bool.isRequired
}

function mapStateToProps ({ browser }) {
  // note: important to _not_ return  browser.width here,
  // as it would force the component to re-render too often.
  // If we needed that level of accuracy we could use browser.innerWidth
  // inside the component, after ensuring we were in a browser.
  return {
    greaterThanSm: browser.greaterThan.sm,
    greaterThanMd: browser.greaterThan.md,
    greaterThanLg: browser.greaterThan.lg,
    greaterThanXl: browser.greaterThan.xl,
    greaterThanXxl: browser.greaterThan.xxl
  }
}

export default connect(mapStateToProps)(VerticalsCarousel)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/VerticalsCarousel.js